<template>
  <div>
    <!-- Floating Button -->
    <CButton color="primary" class="chat-toggle" @click="toggleChat">
      <!-- Icon -->
      <span class="icon">🤖</span>
      <span class="tooltip">Ask AI</span>
    </CButton>

    <!-- Chat Popup -->
    <CCard v-if="isOpen" class="chat-popup shadow-lg">
      <CCardHeader
        class="chat-header d-flex justify-content-between align-items-center"
      >
        <!-- Left Section -->
        <div class="d-flex align-items-center">
          <!-- Avatar -->
          <div class="avatar">🤖</div>

          <!-- Title -->
          <div class="ml-2">
            <div class="title">AI Assistant</div>
            <small class="status text-success">Online</small>
          </div>
        </div>

        <!-- Right Section -->
        <CButton size="sm" color="primary" variant="ghost" @click="toggleChat">
          ✕
        </CButton>
      </CCardHeader>

      <!-- Body -->
      <CCardBody class="p-0">
        <ChatBox />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ChatBox from "./ChatBox.vue";

export default {
  components: { ChatBox },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleChat() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.chat-popup {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 350px;
  height: 450px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}
.chat-toggle {
  position: fixed;
  bottom: 35px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #b8c9f8, #aff4db);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  transition: all 0.3s ease;
}

/* Icon */
.icon {
  font-size: 26px;
}

/* Hover Effect */
.chat-toggle:hover {
  transform: scale(1.1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

/* Pulse Animation */
.chat-toggle::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(78, 115, 223, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.6);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

/* Badge */
.badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  font-size: 10px;
  padding: 3px 6px;
  border-radius: 50%;
}

.tooltip {
  position: absolute;
  right: 70px;
  background: #333;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  transition: 0.2s;
  white-space: nowrap;
}

.chat-toggle:hover .tooltip {
  opacity: 1;
}

</style>
